module.exports = __webpack_public_path__ + "static/smart-search-milk-alice-ab52f63659660698821ce237552d5715.png";